import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import Enquiries from "./pages/admin/Enquiries";
import Jobs from "./pages/admin/Jobs";
import Customers from "./pages/admin/Customers";
import PlumbingPage from "./pages/services/PlumbingPage";
import EmergencyPlumberPage from "./pages/services/EmergencyPlumberPage";
import HandymanPage from "./pages/services/HandymanPage";
import PropertyMaintenancePage from "./pages/services/PropertyMaintenancePage";
import LeakDetectionPage from "./pages/services/LeakDetectionPage";
import BlockedDrainsPage from "./pages/services/BlockedDrainsPage";
import ToiletRepairsPage from "./pages/services/ToiletRepairsPage";
import RadiatorRepairsPage from "./pages/services/RadiatorRepairsPage";
import TapRepairsPage from "./pages/services/TapRepairsPage";
import AirConditioningPage from "./pages/services/AirConditioningPage";
import RefrigerationPage from "./pages/services/RefrigerationPage";
import {
  PlumberRochester, PlumberGillingham, PlumberChatham, PlumberMaidstone,
  HandymanRochester, HandymanGillingham, HandymanChatham,
} from "./pages/locations";
import WhatsAppButton from "./components/seo/WhatsAppButton";
import EmergencyBanner from "./components/seo/EmergencyBanner";
import { Toaster } from "./components/ui/sonner";
import { isAuthenticated } from "./utils/auth";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  return isAuthenticated() ? children : <Navigate to="/admin/login" replace />;
};

// Wraps public pages with the sitewide emergency banner + floating WhatsApp.
// Admin pages render without these to keep the CRM uncluttered.
const PublicShell = ({ children }) => (
  <>
    <EmergencyBanner hideOn={["/admin"]} />
    {children}
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicShell><HomePage /></PublicShell>} />
            <Route path="/services/plumbing" element={<PublicShell><PlumbingPage /></PublicShell>} />
            <Route path="/services/emergency-plumber" element={<PublicShell><EmergencyPlumberPage /></PublicShell>} />
            <Route path="/services/handyman" element={<PublicShell><HandymanPage /></PublicShell>} />
            <Route path="/services/property-maintenance" element={<PublicShell><PropertyMaintenancePage /></PublicShell>} />
            <Route path="/services/leak-detection-repairs" element={<PublicShell><LeakDetectionPage /></PublicShell>} />
            <Route path="/services/blocked-drains" element={<PublicShell><BlockedDrainsPage /></PublicShell>} />
            <Route path="/services/toilet-repairs" element={<PublicShell><ToiletRepairsPage /></PublicShell>} />
            <Route path="/services/radiator-repairs" element={<PublicShell><RadiatorRepairsPage /></PublicShell>} />
            <Route path="/services/tap-repairs" element={<PublicShell><TapRepairsPage /></PublicShell>} />
            <Route path="/services/air-conditioning" element={<PublicShell><AirConditioningPage /></PublicShell>} />
            <Route path="/services/refrigeration" element={<PublicShell><RefrigerationPage /></PublicShell>} />

            <Route path="/locations/plumber-rochester" element={<PublicShell><PlumberRochester /></PublicShell>} />
            <Route path="/locations/plumber-gillingham" element={<PublicShell><PlumberGillingham /></PublicShell>} />
            <Route path="/locations/plumber-chatham" element={<PublicShell><PlumberChatham /></PublicShell>} />
            <Route path="/locations/plumber-maidstone" element={<PublicShell><PlumberMaidstone /></PublicShell>} />
            <Route path="/locations/handyman-rochester" element={<PublicShell><HandymanRochester /></PublicShell>} />
            <Route path="/locations/handyman-gillingham" element={<PublicShell><HandymanGillingham /></PublicShell>} />
            <Route path="/locations/handyman-chatham" element={<PublicShell><HandymanChatham /></PublicShell>} />

            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Protected Admin Routes */}
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="enquiries" element={<Enquiries />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="customers" element={<Customers />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
